import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogoVirustotal = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "#394eff",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10.87 12 0 22.68h24V1.32H0zm10.73 8.52H5.28l8.637-8.448L5.28 3.48H21.6z" })
});
export default SvgLogoVirustotal;
